<template>
  <v-layout fluid fill-height>
    <v-layout v-show="loaded" row wrap fluid class="px-1 idcs-main-back">
      <v-flex xs12 sm12 md6 lg6 xl6 class="pb-1 pr-md-1">
        <v-card class="green lighten-5">
          <v-card-title class="text-uppercase justify-center">
            <div>
              <span class="mr-4">{{$t('summary.day')}}</span>
              <span class="d-inline-block">{{$moment() | dt-only}}</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap fluid class="justify-space-around">
              <v-flex xs12 sm6 md6 lg6 xl6 class="pa-1">
                <SummaryBlock
                  plus
                  :total="total.damt1.damt1"
                  :avg="total.damt1.davg1"
                  :count="total.damt1.dcnt1"
                />
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 xl6 class="pa-1">
                <SummaryBlock
                  :total="total.damt2.damt2"
                  :avg="total.damt2.davg2"
                  :count="total.damt2.dcnt2"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 xl6 class="pb-1 pl-md-1">
        <v-card class="green lighten-5">
          <v-card-title class="text-uppercase justify-center">
            <div>
              <span class="mr-4">{{$t('summary.month')}}</span>
              <span>{{$moment().subtract(1,'month') | dt-month}}</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap fluid class="justify-space-around">
              <v-flex xs12 sm6 md6 lg6 xl6 class="pa-1">
                <SummaryBlock
                  plus
                  :total="total.mamt1.mamt1"
                  :avg="total.mamt1.mavg1"
                  :count="total.mamt1.mcnt1"
                />
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 xl6 class="pa-1">
                <SummaryBlock
                  :total="total.mamt2.mamt2"
                  :avg="total.mamt2.mavg2"
                  :count="total.mamt2.mcnt2"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="my-2">
        <v-simple-table class="elevation-2">
          <thead>
            <tr class="trans-header">
              <th class="text-left">#</th>
              <th v-for="col in transCols" class="text-center" :key="col.v">{{$t('field.'+col.n)}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in lastTrans" :key="item.id" class="trans-row">
              <td>{{ i+1 }}</td>
              <td v-for="col in transCols" :key="col.v">
                <TableFieldCard v-if="col.v == 'card'" :card="item.card"></TableFieldCard>
                <div
                  v-else-if="col.v.indexOf('amount')!=-1"
                  class="text-end"
                >{{ item[col.v] | currency }}</div>
                <div v-else-if="col.v=='status'">{{$t('status.'+item[col.v]) }}</div>
                <div v-else>{{ autoformat(col.v,item[col.v]) }}</div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-flex>
      <v-flex xs12 class="my-2 elevation-2">
        <v-simple-table>
          <thead>
            <tr class="error-header">
              <th class="text-left">#</th>
              <th v-for="col in errorCols" class="text-left" :key="col">{{$t('field.'+col)}}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="error-row" v-for="(item,i) in lastError" :key="item.id">
              <td>{{ i+1 }}</td>
              <td v-for="col in errorCols" :key="col">
                <TableFieldCard v-if="col == 'req_ms'" :card="item[col]"></TableFieldCard>
                <v-btn v-else-if="col=='message'" outlined left color="red" class="log-message">
                  <v-icon class="mr-4">fa-exclamation-triangle</v-icon>
                  {{item[col]}}
                </v-btn>
                <div
                  v-else-if="col=='req_command'"
                >{{$t('card.command.'+item[col]+(item[col]==1200?(item.p1!=0)+'.'+$store.getters.iface:"")) }}</div>
                <div v-else>{{ autoformat(col,item[col]) }}</div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-layout fluid v-show="!loaded" class="align-center text-center">
      <v-flex xs12>
        <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import app from "@/app.js";
import TableFieldCard from "@/components/Table-Field-Card";
import SummaryBlock from "@/components/SummaryBlock";

export default {
  components: { TableFieldCard, SummaryBlock },
  data() {
    return {
      loaded: false,
      transCols: [
        { n: "created", v: "created" },
        { n: "company", v: "company" },
        { n: "subcompany", v: "subcompany" },
        { n: "terminal", v: "terminal" },
        { n: "system", v: "system" },
        { n: "card", v: "card" },
        { n: "amount1." + this.$store.getters.iface, v: "amount1" },
        { n: "amount2." + this.$store.getters.iface, v: "amount2" },
        { n: "status", v: "status" }
      ],
      errorCols: [
        "dt",
        "company",
        "subcompany",
        "req_terminal",
        "message",
        "req_ms",
        "req_command"
      ],
      lastTrans: [],
      lastError: [],
      total: {
        mamt1: { mamt1: 0, mavg1: 0, mcnt1: 0 },
        mamt2: { mamt2: 0, mavg2: 0, mcnt2: 0 },
        damt1: { damt1: 0, davg1: 0, dcnt1: 0 },
        damt2: { damt2: 0, davg2: 0, dcnt2: 0 }
      }
    };
  },
  mounted() {
    this.updateData();
  },
  computed: {},
  methods: {
    titleColor(f) {
      return f ? app.COLOR_MINUS : app.COLOR_PLUS;
    },
    autoformat(col, val) {
      if (col == "amount1") return this.$options.filters.currency(val);
      if (col == "amount2") return this.$options.filters.currency(val);
      if (col == "created") return this.$options.filters["dt-time"](val);
      if (col == "dt") return this.$options.filters["dt-time"](val);
      return val;
    },
    updateData() {
      app.getSummary().then(response => {
        this.lastTrans = response.topTrans;
        this.lastError = response.topLogErrors;
        if (Object.keys(response.mamt1).length != 0)
          this.total.mamt1 = response.mamt1;
        if (Object.keys(response.mamt2).length != 0)
          this.total.mamt2 = response.mamt2;
        if (Object.keys(response.damt1).length != 0)
          this.total.damt1 = response.damt1;
        if (Object.keys(response.damt2).length != 0)
          this.total.damt2 = response.damt2;
        this.loaded = true;
      });
    }
  }
};
</script>
<style scoped>
.trans-header {
  background-color: #ddedd3;
}
.trans-row {
  color: green;
  border-bottom: 1px dashed #adadad;
}
.error-header {
  background-color: mistyrose;
}
.error-row {
  color: red;
  border-bottom: 1px dashed #adadad;
}
.log-message {
  width: 100%;
  justify-content: left !important;
}
</style>